export default "__VITE_ASSET__D6r_mOLp__"